// Backend URL from environment variable or fallback to local development server
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
